var _defs, _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDispMainlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": " \\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1686.3 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #161619;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M789.3,198.3c0-103.2,95.3-188,216.8-196.9,11.5-.8,21.3,6.6,21.3,16.1v186.5c130.9.6,236.8,88.9,236.8,197.7,0,103.2-95.3,188-216.8,196.9-11.5.8-21.3-6.6-21.3-16.1v-186.5c-130.9-.6-236.8-88.9-236.8-197.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.4.6c-1,0-2,0-3,0-.1,0-.2,0-.4,0H18.4C8.2.6,0,10.5,0,22.6v554.9c0,12.1,8.2,22,18.4,22h228.7c.1,0,.2,0,.4,0,1,0,2,0,3,0,138.3,0,250.4-134,250.4-299.4S388.7.6,250.4.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 563.9,
    y: 0.7,
    width: 183.5,
    height: 598.7,
    rx: 20,
    ry: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1686.3,198.3c0-109.2-88.5-197.7-197.7-197.7v.9c-.6-.5-1.3-.8-2.1-.8h-158.9c-11.8,0-21.4,9.6-21.4,21.4v555.9c0,11.8,9.6,21.4,21.4,21.4h140.7c11.8,0,21.4-9.6,21.4-21.4v-182c108.7-.6,196.6-88.9,196.6-197.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispMainlogo);
export default __webpack_public_path__ + "static/media/disp_mainlogo.f6744baeae87df07d55752d4c5bf2ae9.svg";
export { ForwardRef as ReactComponent };